@if (!cerrixTab.showLoader) {
    <div class="detail-page-action-bar flex-action-bar">
        @if (hyperlinksLoaded) {
            <button type="button" (click)="saveHyperlinks()" class="btn btn-cerrix">
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">Save hyperlinks</span>
            </button>
        }
    </div>
}

@if (hyperlinksLoaded) {
    <div class="detail-page-card">
        <hyperlink-manager
            [Hyperlinks]="hyperlinks"
            (HyperlinksChanged)="checkDirty($event)"
            [TargetModule]="targetModule"
        ></hyperlink-manager>
    </div>
}
